import {initElements} from "../define/shared";

export default function initHeader() {
    initElements(".siteHeader", header => {
        const navBtn = header.querySelector(".siteHeader-nav-btn");
        const hamburger = header.querySelector(".hamburger");
        const menuBox = header.querySelector(".siteHeader-menuBox");
        const childMenu = header.querySelectorAll("li.menu-item-has-children");
        const searchBtn = header.querySelector(".siteHeader-search-btn");
        const nav = header.querySelector(".siteHeader-nav");
        const links = header.querySelector(".--links");
        const bottomNav = header.querySelector(".--bottomNav");

        childMenu.forEach(li => {
            const wrapper = document.createElement("div");
            const icon = document.createElement("button");
            const ulWrapper = document.createElement("div");

            wrapper.classList.add("wrapper");
            ulWrapper.classList.add("ulWrapper");
            ulWrapper.setAttribute("inert", "true");
            icon.classList.add("icon", "icon-plus", "menuIcon");
            icon.setAttribute("tabindex", "0");
            icon.setAttribute('aria-expanded', 'false');
            icon.setAttribute('aria-label', 'Öppna undermeny');

            wrapper.appendChild(li.querySelector("a"));
            ulWrapper.appendChild(li.querySelector("ul"));
            wrapper.appendChild(icon);
            li.prepend(ulWrapper);
            li.prepend(wrapper);

            icon.addEventListener("click", () => {
                li.classList.toggle("is--open");
                ulWrapper.toggleAttribute("inert");
                if (li.classList.contains("is--open")) {
                    icon.setAttribute("aria-expanded", "true");
                    icon.setAttribute("aria-label", "Stäng undermeny");
                } else {
                    icon.setAttribute("aria-expanded", "false");
                    icon.setAttribute("aria-label", "Öppna undermeny");
                }
            });
            icon.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    li.classList.toggle("is--open");
                    ulWrapper.toggleAttribute("inert");
                }
            });
        });

        navBtn.addEventListener("click", () => {
            navBtn.classList.toggle("is--open");
            hamburger.classList.toggle("is-active");
            menuBox.classList.toggle("is--open");
            menuBox.toggleAttribute("inert");
            document.querySelector("body").classList.toggle("is--blurred");
            navBtn.classList.contains("is--open") ? navBtn.setAttribute("aria-expanded", "true") : navBtn.setAttribute("aria-expanded", "false");
        });

        document.addEventListener("click", (e) => {
            if (!(menuBox.contains(e.target) || navBtn.contains(e.target))) {
                closeMenu();
            }

            if (!(header.querySelector(".siteHeader-search").contains(e.target))) {
                header.classList.remove("is--search");
                nav.classList.remove("is--search");
            }
        });

        document.body.addEventListener("focusin", (e) => {
            if (!(menuBox.contains(e.target) || navBtn.contains(e.target))) {
                closeMenu();
            }
        });

        window.addEventListener("scroll", () => {
            window.pageYOffset > 0 ? header.classList.add("onscroll") : header.classList.remove("onscroll");
        });

        searchBtn.addEventListener("click", () => {
            header.classList.toggle("is--search");
            nav.classList.toggle("is--search");
            nav.querySelector("input").focus();
            header.classList.contains("is--search") ? searchBtn.setAttribute("aria-expanded", "true") : searchBtn.setAttribute("aria-expanded", "false");
        });

        header.addEventListener("keydown", (e) => {
            if (header.classList.contains("is--search") && e.key === "Escape") {
                header.classList.remove("is--search");
                nav.classList.remove("is--search");
            }

            if (menuBox.classList.contains("is--open") && e.key === "Escape") {
                closeMenu();
            }
        });

        onResize();

        window.addEventListener("resize", () => {
            onResize();
        });

        function onResize() {
            if (window.matchMedia("(max-width: 768px)").matches) {
                bottomNav.appendChild(links);
            } else {
                nav.prepend(links);
            }
        }

        function closeMenu() {
            navBtn.classList.remove("is--open");
            hamburger.classList.remove("is-active");
            menuBox.classList.remove("is--open");
            menuBox.setAttribute("inert", "true");
            document.querySelector("body").classList.remove("is--blurred");
        }
    });
}
